<template>
    <div class="px-4">
    <!-- public warnings/infos -->
        <v-alert v-if="!bewerb.isConfirmed()" text color="primary" icon="mdi-information" class="mb-4">
            <div>Diese Meisterschaft läuft noch, es wird nur das aktuelle Zwischenergebnis gezeigt!</div>
        <!-- accessable without account -->
            <v-btn color="primary" class="mr-5 mt-3 mb-2" @click="refresh()">
                <v-icon>mdi-refresh</v-icon>
                aktualisieren
            </v-btn>
        <!-- accessable only with account -->
            <v-btn v-if="isOperator && !bewerb.isConfirmed()" @click="requestActionConfirm()"
                   color="primary" class="mt-3 mb-2">
                <v-icon>mdi-check</v-icon>Endergebnis bestätigen
            </v-btn>
        </v-alert>
    <!-- accessable only with account, reset complete status -->
        <v-btn v-if="isOperator && bewerb.isConfirmed()" color="#666666" dark @click="requestActionConfirm()"
               class="mb-2">
            <v-icon>mdi-undo</v-icon>Bestätigung zurücksetzen
        </v-btn>
    <!-- change confirmation status -->
        <confirm-dialog :open="confirmBewerbStatus.open" :header="confirmBewerbStatus.header"
                        @reply="processConfirm" query-parameter="confirmBewerbStatus">
            {{ confirmBewerbStatus.question }}
        </confirm-dialog>
    <!-- error snack confirmation status change failed -->
        <v-snackbar v-model="showErrorSnack" color="black" timeout="5000">
            Fehler beim Bestätigen des Ergebnisses! Bitte wende dich an den Systemadministrator.
        </v-snackbar>
    </div>
</template>

<script>
import ConfirmDialog from "@/components/navigation/confirmDialog.vue";

export default {
    name: "meisterschaftBewerbAktionen",
    components: {ConfirmDialog},
    props: ['bewerb', 'landesverbandId'],
    computed: {
        uid(){ return this.$store.state.user.uid },
        isOperator(){ return this.$store.getters["user/isMeisterschaftOperator"](this.landesverbandId)},
    },
    data: () => ({
        confirmBewerbStatus: {
            open: false,
            header: '',
            question: '',
        },
        showErrorSnack: false,
    }),
    methods: {
        refresh(){
            this.$emit('refreshBewerb', this.bewerb.settings.bewerbTyp);
        },
    // change confirmation status for bewerb
        requestActionConfirm(){
            if ( this.bewerb.settings.status !== 'confirmed' ) {
                this.confirmBewerbStatus.header = 'Endergebnis bestätigen';
                this.confirmBewerbStatus.question = 'Möchtest du das Endergebnis für diese Meisterschaft wirklich ' +
                    'bestätigen?'
            } else {
                this.confirmBewerbStatus.header = 'Bestätigung zurücksetzen';
                this.confirmBewerbStatus.question = 'Möchtest du Bestätigung für diese Meisterschaft wirklich ' +
                    'zurücksetzen um Änderungen vornehmen zu können? ' +
                    'Deine Benutzer-ID und der Zeitpunkt werden in diesem Fall zu Dokumentationszwecken gespeichert.'
            }
            this.confirmBewerbStatus.open = true;
        },
        async processConfirm(reply) {
            if ( reply ) await this.processConfirmAction(reply);
            this.confirmBewerbStatus.open = false;
            this.confirmBewerbStatus.header = '';
            this.confirmBewerbStatus.question = '';
        },
        async processConfirmAction(){
            const reply = await this.bewerb.changeStatus(this.uid)
            if ( !reply.successful ) this.showErrorSnack = true
        }
    }
}
</script>

<style scoped>

</style>